import type { DeepPartial } from '@luna/utils-ts';

import type { SavingsConfig } from '../../ProductsConfig';

export const termDepositOverviewConfig: DeepPartial<SavingsConfig['overview']['termDeposit']> = {
    showBalance: true,
    showRollover: true,
    showCapitalization: true,
    showInterestBookingDisposition: true,
    showDepositBookingDisposition: true,
    showInterestBookingDispositionType: {
        interestTransfer: true,
    },
    showCreditInterestRate: true,
};
